import { axiosInstance } from "../axios/axiosConfig";
import { HOME_PAGE_API } from "../constants/api-constants";

export const getFeaturedTeachersData = async (options = {}) => {
  try {
    const response = await axiosInstance.get(HOME_PAGE_API.GET_FEATURED_TEACHERS_API, { params: options });
    return response.data;
  } catch (error) {
    return [];
  }
};

export const getSampleLessonsData = async (options = {}) => {
  try {
    const response = await axiosInstance.get(HOME_PAGE_API.GET_SAMPLE_LESSONS_API, { params: options });
    return response.data;
  } catch (error) {
    return [];
  }
};

export const getVodPackagesData = async (options = {}) => {
  try {
    const response = await axiosInstance.get(HOME_PAGE_API.GET_VOD_PACKAGES_API, { params: options });
    return response.data;
  } catch (error) {
    return [];
  }
};

export const getSpecialPackagesData = async (options = {}) => {
  try {
    const response = await axiosInstance.get(HOME_PAGE_API.GET_SPECIAL_PACKAGES_API, { params: options });
    return response.data;
  } catch (error) {
    return [];
  }
};

export const getVodPackagesLandingSuggestedData = async (options = {}) => {
  try {
    const response = await axiosInstance.get(HOME_PAGE_API.GET_SUGGESTED_VOD_PACKAGES_API, { params: options });
    return response.data;
  } catch (error) {
    return [];
  }
};

export const getTeachersLandingSuggestedData = async (teacherLevel) => {
  try {
    const response = await axiosInstance.get(`${HOME_PAGE_API.GET_SUGGESTED_FEATURED_TEACHERS_API}?levelCode=${teacherLevel}`);
    return response.data;
  } catch (error) {
    return [];
  }
};
